module.exports = __webpack_public_path__ + "assets/img/head3-en.6339258b.png";